// ---------------------------------------------------------------------------
// DocsBrandName — renders "DocsAreSigned" in the YouAreYou house style
// (mirrors BrandName):
//   • "Docs"    bold, dark charcoal
//   • "Are"     bold, dark charcoal
//   • "Signed"  bold, #0052FF blue
//   • green verified/signed badge (circle + checkmark) inline
//
// Used for the DocsAreSigned document-signing surface (always "powered by"
// YouAreYou — pair with <BrandName /> where the lockup calls for it).
// ---------------------------------------------------------------------------

interface DocsBrandNameProps {
  /** Show the green "Signed" badge inline. Default: true */
  showBadge?: boolean;
}

export default function DocsBrandName({ showBadge = true }: DocsBrandNameProps) {
  return (
    <span className="inline-flex items-center gap-0.5 font-bold leading-none">
      <span className="text-[#161b27]">Docs</span>
      <span className="text-[#f08b8b]">Are</span>
      <span className="text-[#161b27]">Signed</span>
      {showBadge && (
        <span
          className="ml-0.5 inline-flex h-[1.1em] w-[1.1em] flex-shrink-0 items-center justify-center rounded-full bg-[#3CB043]"
          aria-label="Signed"
        >
          <svg viewBox="0 0 12 12" fill="none" className="h-[0.65em] w-[0.65em]" aria-hidden="true">
            <path
              d="M2 6.5L4.8 9.2L10 3"
              stroke="white"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </span>
  );
}
